import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ToasterComponent } from '../core/shared/components/toaster.component';
import { ToastService } from '../core/services/toast.service';
import { AuthService } from '../core/services/api-endpoints.service';
import { ApiRoutes } from '../core/shared/apiroutes';
// import { IAuthApiResponse, localStorageKeys, Logging } from '../../../shared/src/import-export';
import { CrudManagementService } from '../core/services/crud-management.service';
import { IAuthApiResponse } from '../core/library/interfaces';
import { localStorageKeys } from '../core/library/constants';
// import Logging from '../core/library/logging';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [ToasterComponent, RouterOutlet,],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  toastService = inject(ToastService);
  title = 'advanced-vts';

  loader: boolean = false

  _authService = inject(AuthService);

  apiService = inject(CrudManagementService);

  constructor() {
    this._authService.authState.set(undefined);
    this.autoAuthUser();
  }

  router = inject(Router);

  autoAuthUser() {
    this.loader = true
    this.apiService
      .get(ApiRoutes.refreshUser)
      .subscribe({
        next: (value) => {
          console.info('autoAuthUser', value);
          const authResponse = value as IAuthApiResponse;


          // Saves the web configuration from the authenticated user's organization to the local storage.
          localStorage.setItem(localStorageKeys.webConfig, JSON.stringify(authResponse.orgId?.webConfig ?? {}));

          if (!authResponse.error) {
            this._authService.setAuthUser(authResponse);
          } else {
            //Do Something
            // this.router.navigate(['']);
            const url = this._authService.getRedirectUrl()
            console.log('app', url)
            if (url.match(/^@[\w]+$/gm)) {
              console.log(url)
            } else {
              this.router.navigateByUrl('/', { replaceUrl: true });
            }
          }
        },
        error: (error) => {
          // Logging.error('autoAuthUser error', error);
          // this._authService.logout();
          this.router.navigateByUrl('/');
          this.loader = false
        },
        complete: () => { this.loader = false },
      });
  }
}
